<template>
  <div class="form-module">
    <div class="container">
      <div class="title">{{ propertiesObject.title }}</div>
      <button class="close-btn" @click="sendDataToParent('close')">×</button>
    </div>
    <div class="form-container">
      <!-- 添加管点提示 -->
      <div v-if="propertiesObject.title == '添加管点'">
        <div class="tips" v-if="!transCoordinate">
          <div style="display: flex; align-items: center; padding-left: 3px;" v-if="coordinateTips">
            <span style="color: red; font-size: 13px;">请选择坐标！！！</span>
          </div>
          <div style="font-size: 14px; display: flex; align-items: center;">
            <img :src="require(`@/assets/collect/cue_coordinate.svg`)">
            <span>请点击地图获取坐标</span>
          </div>
        </div>
        <div class="tips" v-else>
          <div style="display: flex; align-items: center; padding-left: 3px;">
            <img :src="require(`@/assets/collect/warn.svg`)" style="height: 13px; width: 13px;">
            <span style="color: #bec0bf; font-size: 10px;">当前为WGS84坐标,新增后会转为CGCS2000</span>
          </div>
          <div style="font-size: 14px; display: flex; align-items: center;">
            <img :src="require(`@/assets/collect/cue_coordinate.svg`)">
            <span>X:&nbsp;</span> <span style="color: #fe8d8f;">{{ monitorCoordinate.lng.toFixed(7) }}</span>
            &nbsp;&nbsp;
            <span>Y:&nbsp;</span> <span style="color: #fe8d8f;">{{ monitorCoordinate.lat.toFixed(7) }}</span>
          </div>
        </div>
      </div>
      <!-- 添加管线提示 -->
      <div v-else-if="propertiesObject.title == '添加管线'">
        <div class="tips">
          <div style="font-size: 14px; display: flex; align-items: center;">
            <img :src="require(`@/assets/collect/cue_coordinate.svg`)">
            <span>请点击管点获取连线信息</span>
          </div>
        </div>
      </div>
      <!-- 插入管点提示 -->
      <div v-else-if="propertiesObject.title == '插入管点'">
        <div class="tips">
          <div style="font-size: 14px; display: flex; align-items: center;">
            <img :src="require(`@/assets/collect/cue_coordinate.svg`)">
            <span>当前插入线 :</span>
          </div>
          <div style="padding-left: 5px;">
            <span style="color: #fe8d8f; font-size: 12px;">{{ insertionLine.connectionPointNumber + ' - ' +
              insertionLine.theDotNumberIsConnected }}</span>
          </div>
        </div>
      </div>
      <div class="form">
        <a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="rules">
          <a-form-model-item v-for="(item, index) in formList" :key="index" :label="item.label" colon
            style="font-weight: 200; margin: 0;" class="custom-form-item" :prop="item.value">

            <!-- 文字输入框 -->
            <a-input v-if="item.type == 'input'" v-model="form[item.value]" size="small"
              :placeholder="'请输入' + item.label" allowClear :disabled="item.disabled" />

            <!-- 数字输入框 -->
            <a-input-number v-if="item.type == 'number'" v-model="form[item.value]" size="small"
              :placeholder="'请输入' + item.label" allowClear style="width: 150px;" />

            <!-- 下拉选择框 -->
            <div class="select" v-else-if="item.type == 'select'">
              <a-select v-if="!item.inputData.flag" allowClear v-model="form[item.value]" size="small"
                :placeholder="'请选择' + item.label" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                :style="item.inputData.data ? 'width: 120px;' : ''" @change="verifyKey(item)">
                <a-select-option v-for="(value, key) in item.list" :key="key" :value="value">
                  {{ value }}
                </a-select-option>
              </a-select>
              <a-input v-else v-model="form[item.value]" size="small" :placeholder="'请输入' + item.label" allowClear
                style="width: 120px;" />
              <!-- 切换输入框按键 -->
              <div v-if="item.inputData.data" style="display: inline-block; margin-left: 12px">
                <a-icon type="retweet" @click="toggleModule(item)" />
              </div>
            </div>

            <!-- 树型下拉框 -->
            <div class="options" v-else-if="item.type == 'options'">
              <!-- 默认样式 -->
              <a-cascader v-if="!item.inputData.flag" v-model="form[item.value]" :options="item.options" size="small"
                :display-render="displayRender" expand-trigger="hover" :placeholder="'请选择' + item.label"
                @change="onChange" :getPopupContainer="(triggerNode) => triggerNode.parentNode"
                :style="item.inputData.data ? 'width: 120px;' : ''" />
              <a-input v-else v-model="form[item.value]" size="small" :placeholder="'请输入' + item.label" allowClear
                style="width: 120px;" />
              <!-- 切换输入框按键 -->
              <div v-if="item.inputData.data" style="display: inline-block; margin-left: 12px">
                <a-icon type="retweet" @click="toggleModule(item)" />
              </div>
            </div>

            <!-- 时间选择框 -->
            <div v-else-if="item.type == 'time'">
              <a-date-picker v-model="form[item.value]" show-time type="date" size="small" class="picker" />
            </div>

            <!-- 带key值下拉框 -->
            <div class="select" v-else-if="item.type == 'keySelect'">
              <a-select allowClear v-model="form[item.value]" size="small" :placeholder="'请选择' + item.label"
                :getPopupContainer="(triggerNode) => triggerNode.parentNode" @change="verifyKey(item)">
                <a-select-option v-for="(value, key) in item.list" :key="key" :value="value.key">
                  {{ value.text }}
                </a-select-option>
              </a-select>
            </div>
          </a-form-model-item>

        </a-form-model>
      </div>
      <div class="form-buttons">
        <a-button style="margin-right: 10px;" @click="resetForm">
          重置
        </a-button>
        <a-button type="primary" @click="onSubmits">
          确定
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>



export default {
  name: 'FormModule',
  props: {
    monitorCoordinate: Object, //当前监听坐标
    propertiesObject: Object, //自定义属性
    currentProjectId: {
      type: [String, Number],
      required: true
    }, //当前项目id
    projectData: Object, //当前项目类型
    getConnectionPoint: {
      type: Object,
      default: () => null,
    },
  },
  watch: {
    propertiesList (newVal, oldVal) {
      console.log('propertiesList 发生了变化:', '旧值：', oldVal, '新值：', newVal);
    },
    monitorCoordinate (newVal, oldVal) {
      console.log('monitorCoordinate 发生了变化:', '旧值：', oldVal, '新值：', newVal);
      this.markerDefaultAttribute.obscureLatitude = newVal.lat;
      this.markerDefaultAttribute.obscureLongitude = newVal.lng;
      this.transCoordinate = [newVal.lat.toFixed(3), newVal.lng.toFixed(3)]
    },
    getConnectionPoint (newVal, oldVal) {
      console.log('getConnectionPoint 发生了变化:', '旧值：', oldVal, '新值：', newVal);
      this.getConnectionPointToLine(newVal.data);
    }
  },
  created () {
    console.log('FormModule创建了');
    console.log(this.propertiesObject);

    //将$message挂载至getContainer
    this.$message.config({
      top: `100px`,
      duration: 2,
      maxCount: 1,
      getContainer: () => document.getElementById('pipeline-mapping'), // 指定挂载节点
    });
    let basicsList = this.propertiesObject.type == 'marker' ? this.markerBasics : this.lineBasics
    this.formList = [...basicsList, ...this.propertiesObject.list]
    console.log(this.formList);

    this.rules = this.propertiesObject.type == 'marker' ? this.markerRules : this.lineRules
    //如果有data则是修改操作
    if (this.propertiesObject.data
      && this.propertiesObject.title != '插入管点'
    ) {
      // 动态初始化 form 对象
      this.form = this.analyzeData(this.propertiesObject.data, basicsList, this.formList);
      this.transCoordinate = [this.propertiesObject.data.measurementLongitude, this.propertiesObject.data.measurementLatitude]
    } else {
      if (this.propertiesObject.title == '插入管点') {
        this.formList = [...this.insertionMarkerBasics, ...this.formList];
        this.insertionLine = this.propertiesObject.data.options.element;
        this.markerDefaultAttribute = {
          pipelineInfoId: this.propertiesObject.data.options.element.id, //插入线id
          obscureLatitude: this.propertiesObject.data.latlng.lat,//模糊纬度
          obscureLongitude: this.propertiesObject.data.latlng.lng//模糊经度
        }
        //获取继承属性
        this.getInheritMarker();
      }
      // 动态初始化 form 对象
      this.form = this.defaultData(basicsList);
    }

    if (this.propertiesObject.title == '添加管点') {
      this.markerDefaultAttribute = {
        obscureLatitude: '',//模糊纬度
        obscureLongitude: ''//模糊经度
      }
      //获取继承属性
      this.getInheritMarker();
    }
    console.log(this.form);
  },
  data () {
    return {
      /**表单基础信息 */
      form: {},
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      formList: [], //显示表单列表
      transCoordinate: undefined,
      inheritLineUrl: '/gis-manager/diagramming/pipe/recently/add/infos', //继承线
      inheritMarkerUrl: '/gis-manager/diagramming/point/recently/add/',  //继承点
      /*管点默认信息 */
      //表单显示默认属性
      markerBasics: [
        { label: '物探点号', type: 'input', value: 'intuitionPoint' },
      ],
      //插入管点默认属性
      insertionMarkerBasics: [
        { label: '插入埋深', type: 'number', value: 'burialDepth' }
      ],
      insertionLine: {}, //被插入线对象
      coordinateTips: false, //新增管点的提示
      //表单不显示默认属性
      markerDefaultAttribute: {},
      /*管线默认信息 */
      //表单显示默认属性
      lineBasics: [
        { label: '起点点号', type: 'input', value: 'connectionPointNumber', disabled: true },
        { label: '终点点号', type: 'input', value: 'theDotNumberIsConnected', disabled: true },
        { label: '起点埋深', type: 'number', value: 'connectionPointDeep' },
        { label: '终点埋深', type: 'number', value: 'theDotNumberIsDeep' },
        { label: '连接方向', type: 'keySelect', value: 'flowDirection', list: [{ text: '未知流向', key: 0 }, { text: '连接流向被连接点', key: 1 }, { text: '被连接流向连接点', key: 2 }], inputData: { flag: false } },
      ],
      //表单不显示默认属性
      lineDefaultAttribute: {},
      /*表单验证字段 */
      rules: {}, //表单验证字段
      markerRules: {
        intuitionPoint: [{ required: true, message: '请填写物探点号', trigger: 'blur' },]
      },
      lineRules: {
        connectionPointNumber: [{ required: true, message: '请填写起点点号', trigger: 'blur' }],
        theDotNumberIsConnected: [{ required: true, message: '请填写终点点号', trigger: 'blur' }]
      },
    }
  },
  methods: {
    // 发送给父组件信息
    sendDataToParent (item) {
      console.log(item);
      // 触发自定义事件 'child-to-parent'，并传递数据
      this.$emit("form-to-parent", item);
    },
    //重置form表单 修改-新增 不同重置
    resetForm () {
      let basicsList = this.propertiesObject.type == 'marker' ? this.markerBasics : this.lineBasics
      if (this.propertiesObject.data) { //修改重置 会保留原来属性
        this.form = this.analyzeData(this.propertiesObject.data, basicsList, this.formList);
      } else { //新增重置不保留原来属性
        this.form = this.defaultData(basicsList);
      }
      if (this.propertiesObject.title == '添加管线') {
        this.$emit("on-line", { type: 'reset' });
      }
    },
    /**
     * 提交表单
     * 注意: 
     * 先筛选默认表单对象，在筛选自定义表单
     * 如果类型为options 则要获取最后一个元素值为value
     */
    onSubmits () {
      //添加管点验证有没有坐标
      if (this.propertiesObject.title == '添加管点') { if (!this.verifyAddMarker()) { return; } }
      //编辑管点添加属性
      else if (this.propertiesObject.title == '编辑管点') { this.markerDefaultAttribute.id = this.propertiesObject.data.id }
      //编辑管线添加属性
      else if (this.propertiesObject.title == '编辑管线') { this.lineDefaultAttribute.id = this.propertiesObject.data.id }

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const clonedForm = _.cloneDeep(this.form); // 使用 Lodash
          let formData = this.generateCustomList(clonedForm);
          let parameter = {
            data: formData,
            type: this.propertiesObject.type,
            controls: this.propertiesObject.title
          }
          //通知父组件删除表单组件
          this.sendDataToParent(parameter);
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
     * 验证添加管点表单
     */
    verifyAddMarker () {
      if (this.markerDefaultAttribute.obscureLatitude == '' || this.markerDefaultAttribute.obscureLongitude == '') {
        this.coordinateTips = true;
        return false;
      } else {
        return true;
      }
    },

    /**
     * 根据固定属性生成自定义列表
     */
    generateCustomList (form) {
      let formData = {}
      let basicsList = this.propertiesObject.type == 'marker' ? this.markerBasics : this.lineBasics //获取固定列表
      basicsList.forEach(item => {
        formData[item.value] = form[item.value]
        delete form[item.value]
      })
      console.log(form);

      //自定义列表
      let attributeNameValueList = [];
      console.log(this.formList);

      this.propertiesObject.list.forEach(element => {
        if (form.hasOwnProperty(element.label)) {
          if (form[element.label] != undefined) {
            attributeNameValueList.push(
              {
                attributeName: element.label,
                attributeValue: Array.isArray(form[element.label]) ? form[element.label][form[element.label].length - 1] : form[element.label]
              }
            )
          } else {
            attributeNameValueList.push(
              {
                attributeName: element.label,
                attributeValue: null
              }
            )
          }
        } else {
          attributeNameValueList.push(
            {
              attributeName: element.label,
              attributeValue: null
            }
          )
        }
      });
      formData.attributeNameValueList = attributeNameValueList;
      let defaultAttribute = this.propertiesObject.type == 'marker' ? this.markerDefaultAttribute : this.lineDefaultAttribute //获取不显示固定列表
      return { ...formData, ...defaultAttribute };
    },
    // 默认初始化 form 对象
    defaultData (formAcquiesce) {
      let formData = {}
      //先循环formAcquiesce 填充默认属性
      formAcquiesce.forEach(item => {
        formData[item.value] = undefined;
      })
      return formData;
    },
    // 动态初始化 form 对象
    analyzeData (params, formAcquiesce, formCustom) {
      console.log(params);
      console.log(formAcquiesce);
      console.log(formCustom);
      if (params.attributeNameValueList == undefined) {
        params.attributeNameValueList = []
      }
      let formData = {}
      //先循环formAcquiesce 填充默认属性
      formAcquiesce.forEach(item => {
        const value = params?.[item.value];
        if (value !== undefined && value !== null && value !== "") {
          formData[item.value] = value;
        }
      })
      formCustom.forEach(item => {
        params['attributeNameValueList'].forEach(param => {
          if (item.label == param.attributeName) {
            if (item.type == 'options') {
              formData[item.label] = param?.attributeValue || undefined;
              let value = this.optionsResolver(item, formData);
              if (value == undefined) {
                item.inputData.flag = true;
                formData[item.label] = param?.attributeValue
              } else {
                item.inputData.flag = false;
                formData[item.value] = value;
              }
            } else {
              formData[item.label] = param?.attributeValue || undefined;
            }
          }
        })
      })
      console.log(formData);
      console.log(formCustom);

      return formData;
    },
    /**
     * 获取连接点到线表单上
     */
    getConnectionPointToLine (item) {
      const { intuitionPoint } = item;
      const {
        connectionPointNumber,
        theDotNumberIsConnected,
      } = this.form;
      // 如果两个值都已经存在，提示用户
      if (connectionPointNumber && theDotNumberIsConnected) {
        this.$message.warning('已经有两个连线点，不能再添加新的点！');
        return;
      }
      // 检查是否重复
      const isDuplicate = intuitionPoint === connectionPointNumber || intuitionPoint === theDotNumberIsConnected;

      if (isDuplicate) {
        this.$message.warning("重复的点号，不能添加:" + intuitionPoint);
        return;
      }
      // 赋值逻辑
      if (!connectionPointNumber) {
        this.$set(this.form, 'connectionPointNumber', intuitionPoint);
        this.$emit("on-line", {
          type: 'marker',
          intuitionPoint
        });
      } else if (!theDotNumberIsConnected) {
        this.$set(this.form, 'theDotNumberIsConnected', intuitionPoint);
        this.$emit("on-line", {
          type: 'marker',
          intuitionPoint
        });
      }
      //获取继承线属性
      if (this.form.connectionPointNumber && this.form.theDotNumberIsConnected) {
        console.log(this.projectData);

        let parameter = {
          projectManagementId: this.currentProjectId,
          tubeClassCode: this.projectData.tubeClassCode,
          connectionPointNumber: this.form.connectionPointNumber,
          theDotNumberIsConnected: this.form.theDotNumberIsConnected,
        }
        this.$emit("on-line", { type: 'line' });
        this.$http.post(this.inheritLineUrl, parameter).then(res => {
          console.log(res);
          // 动态初始化 form 对象
          this.form = this.analyzeData(res.data, this.lineBasics, this.formList);
        })
      }
    },
    /**组件操作 */
    //切换框
    toggleModule (item) {
      console.log(item);
      item.inputData.flag = !item.inputData.flag
      //如果是树型菜单
      if (item.inputData.flag && item.type == 'options') {
        let value = this.form[item.value];
        //获取树型菜单中最后的元素
        this.form[item.value] = value[value.length - 1]
      } else if (item.type == 'options') {        //避免冲突切换树形菜单 
        this.form[item.value] = this.optionsResolver(item, this.form);
      } else {

      }
    },
    //树状下拉框
    onChange (value) {
      console.log(value);
    },
    /**
     * 树状选择框解析器
     * 因为树状选择框中绑定的值不同所以需要解析 
     * @param item 树型菜单对象
     * 
     */
    optionsResolver (item, form) {
      console.log(item);
      console.log(form);

      //返回值
      let value = undefined;
      //循环树型菜单属性
      item.options.forEach(array => {
        //循环子属性
        array.children.forEach(element => {
          //如果当前输入值与子属性列表中向匹配则添加为 [key,value] 数组
          if (element.value == form[item.value]) {
            value = [array.value, element.value]
          }
        })
      })
      return value;
    },
    //展示树型菜单最后一个值
    displayRender ({ labels }) {
      return labels[labels.length - 1];
    },
    //验证该列是否为其他列冲突列 如果为冲突列则清除其他列数据
    verifyKey (item) {
      //如果key为0则不会和其它值发生冲突
      if (item.key == 0) {
        return;
      } else {
        let keyList = []
        this.propertiesObject.list.forEach(obj => {
          if (obj.key == item.key && obj.value != item.value) {
            keyList.push(obj.value)
          }
        })
        console.log(keyList);
        keyList.forEach(key => {
          this.form[key] = undefined
        })
      }
    },
    //获取继承点
    getInheritMarker () {
      this.$http.get(this.inheritMarkerUrl + this.projectData.tubeClassCode + '/' + this.currentProjectId).then(res => {
        if (res.data != null) {
          // 动态初始化 form 对象
          this.form = this.analyzeData(res.data, this.markerBasics, this.formList);
        }
      })
    },
  }
};
</script>

<style lang="less" scoped>
.form-module {
  padding: 2px 9px;
  // caret-color: transparent;
}

/* 容器样式 */
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #ccc;
  /* 底部分界线 */
}

.title {
  flex: 1;
  /* 标题占据剩余空间 */
  font-size: 15px;
  padding-left: 10px;
}

.close-btn {
  cursor: pointer;
  /* 鼠标悬停时显示手型 */
  font-size: 25px;
  color: #5e5c5c;
  background: none;
  border: none;
  padding: 0 7px;
  /* 可根据需要调整内边距 */
}

.close-btn:hover {
  color: #c00;
  /* 鼠标悬停时改变颜色 */
}

/* 表单容器 */
.form-container {
  display: flex;
  flex-direction: column;
  height: 600px;
  /* 设置固定高度 */
}

/* 表单内容 */
.form {
  flex: 1;
  /* 占据剩余空间 */
  overflow-y: auto;
  /* 超出时显示垂直滚动条 */
  overflow-x: hidden;
  /* 隐藏水平滚动条 */
  padding-left: 10px;
}

/* 底部按钮 */
.form-buttons {
  padding: 10px;
  border-top: 1px solid #ccc;
  /* 顶部边框 */
  text-align: right;
  /* 按钮右对齐 */
}

/deep/ .ant-form-item-label>label {
  font-size: 12px;
  /* 调整标签文字大小 */
}

.picker {
  min-width: 162px !important;
  width: 150px;
}

.dropdown {
  position: absolute;
  z-index: 1000;
  width: 150px;
  background-color: white;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-height: 200px;
  overflow-y: auto;
  ;
  /* 将 dropdown-radio 置顶 */

  .dropdown-radio {
    position: sticky;
    /* 固定在顶部 */
    top: 0;
    /* 固定在顶部 */
    width: 100%;
    overflow-x: auto;

    /* 允许水平滚动 */
  }

  .radio-group {
    display: flex;
    flex-wrap: wrap;
    /* 允许换行 */
  }

  .radio-button {
    flex: 1 1 50%;
    /* 每两个占满一行 */
    box-sizing: border-box;
    text-align: center;
    line-height: 30px;
  }
}


/* 下拉选项 */
.dropdown-item {
  padding-left: 12px;
  font-size: 12px;
  font-weight: 500;
  height: 35px;
  line-height: 35px;
  cursor: pointer;
}

/* 下拉选项悬停效果 */
.dropdown-item:hover {
  background-color: #f0f5ff;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.slide-down-enter-active {
  animation: slideDown 0.3s ease;
}

.slide-down-leave-active {
  animation: slideDown 0.3s ease reverse;
}

.tips {
  margin-top: 3px;
  background-color: #e9f5ff;
  border-radius: 5%;
  padding: 8px;

  img {
    margin-right: 5px;
    width: 20px;
    height: 18px;
  }
}


/deep/ .ant-form-explain {
  font-size: 12px;
}
</style>